"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cryptoDestinationCheck = void 0;
/**
 * Checks if the currency uses destination tags or memos.
 *
 * @param cryptoCurrency - The currency code to check against.
 * @param cryptoWithDestination - Optional array of currency codes that use destination tags or memos.
 * @returns A boolean indicating whether the currency uses destination tags or memos.
 */
const cryptoDestinationCheck = (cryptoCurrency, cryptoWithDestination) => {
    // Don't validate if no selected currencyCode/cryptoCurrency
    if (!cryptoCurrency) {
        return false;
    }
    // Validate only if included from cryptoWithDestinationMemo
    return (cryptoWithDestination === null || cryptoWithDestination === void 0 ? void 0 : cryptoWithDestination.includes(cryptoCurrency)) || false;
};
exports.cryptoDestinationCheck = cryptoDestinationCheck;
